import React, { useContext } from "react";
import { constants } from "shared/constants";
import pl from "shared/messages/pl";
import styles from "./targetProgressBar.module.scss";
import { Flex, Text } from "@fluentui/react-northstar";
import { toFixedNumber } from "utils/numberUtils";
import { IThemeTeamsClient } from "msTeamsUI/lib/withTheme";
import classNames from "classnames";
import { MsTeamsContext } from "msTeams/store";

interface TargetProgressBarProps {
    showWarningIndicator: boolean;
    targetProgress?: number;
    targetProgressValue?: number;
    todayProgressValue?: number;
    highlightTextTargetProgressValue: boolean;
    showTodayProgressValue: boolean;
    showOnlyProgressValue: boolean;
}

const TargetProgressBar: React.FC<TargetProgressBarProps> = (props: TargetProgressBarProps) => {
    const msTeamsContext = useContext(MsTeamsContext);

    const mapProgressToWidth = (progressValue: number | undefined) => {
        let value = 0;
        if (progressValue && progressValue > 0) {
            value = progressValue <= 100 ? progressValue : 100;
        }

        return `${value}${constants.percent}`;
    };

    const getBackgroundColorClassName = (): string | undefined => {
        if (!props.showWarningIndicator) {
            if (msTeamsContext.currentMsTeamsThemeName !== IThemeTeamsClient.Default) {
                return styles.progressIndicatorDefaultDarkTheme;
            }
        }

        return undefined;
    };

    const getContainerBorderClassName = (): string => {
        if (msTeamsContext.currentMsTeamsThemeName === IThemeTeamsClient.Default) {
            return styles.progressIndicatorGraphicContent;
        }
        return styles.progressIndicatorGraphicContentDarkTheme;
    };

    return (
        <Flex>
            <div
                className={styles.progressIndicatorTextContent}
                title={props.targetProgressValue?.toString()}
                style={{
                    minWidth: props.highlightTextTargetProgressValue ? "60px" : "46px",
                    maxWidth: props.highlightTextTargetProgressValue ? "60px" : "46px",
                }}
            >
                <Text weight="semibold" size={props.highlightTextTargetProgressValue ? "large" : "medium"}>
                    {props.targetProgressValue
                        ? `${toFixedNumber(props.targetProgressValue, 1).toLocaleString("pl")}${constants.percent}`
                        : constants.dash}
                </Text>
            </div>

            {props.showOnlyProgressValue && (
                <div className={getContainerBorderClassName()}>
                    {props.showTodayProgressValue && (
                        <div className={styles.over}>
                            <div style={{ width: mapProgressToWidth(props.todayProgressValue) }}>&nbsp;</div>
                            <div>
                                <div className={styles.todayIndicatorLine} />
                                <div className={styles.todayIndicatorText}>{pl.reports.targetProgressBar.today}</div>
                            </div>
                        </div>
                    )}
                    <div
                        className={classNames(
                            props.showWarningIndicator
                                ? styles.progressIndicatorWarning
                                : styles.progressIndicatorDefault,
                            getBackgroundColorClassName()
                        )}
                        style={{
                            width: mapProgressToWidth(props.targetProgress),
                        }}
                    />
                </div>
            )}
        </Flex>
    );
};

export default TargetProgressBar;
